import { useNavigate, useParams } from "react-router-dom";
import { CollectionResources } from "../../collections/CollectionResources"
import { useSelector } from "react-redux";
import { selectEditingCollection } from "../../../redux/features/appData";
import { useEffect } from "react";

type WazKBManageProps = {

}

export const WazKBManage = ({} : WazKBManageProps) => {
    const navigate = useNavigate();

    const { collectionId } = useParams();

    const editingCollection = useSelector(selectEditingCollection);

    useEffect(() => {
        if (!collectionId) {
            navigate("/waz/kb/manage/" + editingCollection?.id);
        }
    
    }, [collectionId]);

    return (
        <CollectionResources />
    )
}